<div class="statistics-info-wrapper">
    <div class="row-header-cell">Salg markert med mørkeblått inkluderes i utvalget</div>

    <div class="row-cell left header">Før perioden</div>
    <div class="row-cell mid info-graphics">
        <div class="arrow left"></div>
        <div
            class="period-type-icon"
            [class.registered-icon]="searchViewOptions().periodDefinitionType === periodType.Registered"
            [class.sold-icon]="searchViewOptions().periodDefinitionType === periodType.Sold"
            [class.inmarket-icon]="searchViewOptions().periodDefinitionType === periodType.InMarket"
        ></div>
        <div class="arrow right"></div>
    </div>
    <div class="row-cell right header">Etter perioden</div>

    <div class="row-cell left"><div class="box stand-alone left">Reg og solgt</div></div>
    <div class="row-cell mid"><div class="box mid empty"></div></div>
    <div class="row-cell right"><div class="box right empty"></div></div>

    <div class="row-cell left">
        <div
            class="box left dashed"
            [class.highlight]="
                searchViewOptions().periodDefinitionType === periodType.Sold || searchViewOptions().periodDefinitionType === periodType.InMarket
            "
        >
            Registrert
        </div>
    </div>
    <div class="row-cell mid">
        <div
            class="box mid"
            [class.highlight]="
                searchViewOptions().periodDefinitionType === periodType.Sold || searchViewOptions().periodDefinitionType === periodType.InMarket
            "
        >
            Solgt
        </div>
    </div>
    <div class="row-cell right"><div class="box right empty"></div></div>

    <div class="row-cell left">
        <div class="box left dashed" [class.highlight]="searchViewOptions().periodDefinitionType === periodType.InMarket">Registrert</div>
    </div>
    <div class="row-cell mid"><div class="box mid" [class.highlight]="searchViewOptions().periodDefinitionType === periodType.InMarket"></div></div>
    <div class="row-cell right">
        <div class="box right dashed" [class.highlight]="searchViewOptions().periodDefinitionType === periodType.InMarket">Solgt</div>
    </div>

    <div class="row-cell left">
        <div class="box left dashed" [class.highlight]="searchViewOptions().periodDefinitionType === periodType.InMarket">Registrert</div>
    </div>
    <div class="row-cell mid"><div class="box mid" [class.highlight]="searchViewOptions().periodDefinitionType === periodType.InMarket"></div></div>
    <div class="row-cell right">
        <div class="box right dashed infinite" [class.highlight]="searchViewOptions().periodDefinitionType === periodType.InMarket">Ikke solgt</div>
    </div>

    <div class="row-cell left"><div class="box left empty"></div></div>
    <div class="row-cell mid"><div class="box mid highlight">Reg og solgt</div></div>
    <div class="row-cell right"><div class="box right empty"></div></div>

    <div class="row-cell left"><div class="box left empty"></div></div>
    <div class="row-cell mid">
        <div
            class="box mid"
            [class.highlight]="
                searchViewOptions().periodDefinitionType === periodType.Registered || searchViewOptions().periodDefinitionType === periodType.InMarket
            "
        >
            Registrert
        </div>
    </div>
    <div class="row-cell right">
        <div
            class="box right dashed"
            [class.highlight]="
                searchViewOptions().periodDefinitionType === periodType.Registered || searchViewOptions().periodDefinitionType === periodType.InMarket
            "
        >
            Solgt
        </div>
    </div>

    <div class="row-cell left"><div class="box left empty"></div></div>
    <div class="row-cell mid">
        <div
            class="box mid"
            [class.highlight]="
                searchViewOptions().periodDefinitionType === periodType.Registered || searchViewOptions().periodDefinitionType === periodType.InMarket
            "
        >
            Registrert
        </div>
    </div>
    <div class="row-cell right">
        <div
            class="box right dashed infinite"
            [class.highlight]="
                searchViewOptions().periodDefinitionType === periodType.Registered || searchViewOptions().periodDefinitionType === periodType.InMarket
            "
        >
            Ikke solgt
        </div>
    </div>

    <div class="row-cell left"><div class="box left empty"></div></div>
    <div class="row-cell mid"><div class="box mid empty"></div></div>
    <div class="row-cell right"><div class="box right stand-alone right">Reg og solgt</div></div>

    <div class="row-cell left"><div class="box left empty"></div></div>
    <div class="row-cell mid"><div class="box mid empty"></div></div>
    <div class="row-cell right"><div class="box right stand-alone infinite">Reg, ikke solgt</div></div>

    <div class="row-cell left bottom"><div class="box left empty"></div></div>
    <div class="row-cell mid bottom"><div class="box mid spacing">&nbsp;</div></div>
    <div class="row-cell right bottom"><div class="box right empty"></div></div>
</div>
